import bridgeSearchCondition from './bridgeSearchCondition'
import bridgeReservationInput from './bridgeReservationInput'

bridgeSearchCondition('.js-car-search-condition')
bridgeReservationInput('.js-car-reservation-input')
// window.addEventListener('keydown', event => {
// 	if (event.key !== 'f') return
// 	scApp.foo()
// })
